import React from 'react';
import {Box, Pagination, Stack, Typography} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicPaginationSizes = () => {
    return (
        <Stack spacing={2} p={3}>
            <Box>
                <Typography variant={"h6"} color={"text.primary"}>
                   Pagination Sizes
                </Typography>
                <Typography variant={"body2"} color={"text.primary"}>
                    Default size is set to <strong>Medium</strong>.
                </Typography>
            </Box>
            <Box sx={{ width: "80%", alignSelf: "center" }}>
                <PreviewAndEditor
                    language="js"
                    title={"table sizes.'small' || 'medium' || 'large'"}
                    value={"                    <Pagination count={10} size={\"small\"} />\n\n\n" +
                        "                        <Pagination count={10} />\n\n\n" +
                        "                        <Pagination count={10} size={\"large\"} />"}>
                    <Stack direction={"column"} spacing={2} alignItems={"center"}>
                        <Pagination count={10} size={"small"} />
                        <Pagination count={10} />
                        <Pagination count={10} size={"large"} />
                    </Stack>
                </PreviewAndEditor>
            </Box>
        </Stack>
    );
};

export default BasicPaginationSizes;